import HeaderBanner from "../../../components/HeaderBanner/index";
// ✅ Import all files directly so they get bundled
import NoticeHybrid from "./Assets/Notice1Regardingonlineclasses.jpeg";
import NoticeOnline from "./Assets/Notice_Conducteofclassesinhybridmodeonsat.jpeg";
import React from "react";
import SopFile from "./Assets/SOP.pdf";
import TT_Allied from "./Assets/TT_Alliedhealthsciences.pdf";
import TT_Applied from "./Assets/TT_AppliedSciences.PNG";
import TT_BVoc from "./Assets/TT_B.VOC(SD)B.ScGWD.jpeg";
import TT_CSE from "./Assets/TT_CSEDSTimetable.jpeg";
import TT_Civil from "./Assets/TT_DeptCivil.pdf";
import TT_ECE from "./Assets/TT_ECE.jpeg";
import TT_IT from "./Assets/TT_IT.PNG";
import TT_Management from "./Assets/TT_Management.jpg";
import TT_Pharmacy from "./Assets/TT_B PharmacyD.Pharmacy.jpeg";

const CompensatoryClasses = () => {
  const files = {
    notices: [
      {
        name: "Notice - Conduct of Classes in Hybrid Mode (Saturday)",
        path: NoticeOnline,
      },
      {
        name: "Notice Regarding Online Classes",
        path: NoticeHybrid,
      },
    ],
    sop: [{ name: "SOP Document", path: SopFile }],
    timetables: [
      { name: "Timetable - Allied Health Sciences", path: TT_Allied },
      { name: "Timetable - Applied Sciences", path: TT_Applied },
      { name: "Timetable - B.Pharmacy / D.Pharmacy", path: TT_Pharmacy },
      { name: "Timetable - B.Voc (SD) / B.Sc GWD", path: TT_BVoc },
      { name: "Timetable - CSE/DS", path: TT_CSE },
      { name: "Timetable - Civil Department", path: TT_Civil },
      { name: "Timetable - ECE", path: TT_ECE },
      { name: "Timetable - IT", path: TT_IT },
      { name: "Timetable - Management", path: TT_Management },
      { name: "Timetable - HM", path: TT_Management },
    ],
  };

  document.title = "Compensatory Classes";

  return (
    <div>
      {/* Header Banner */}
      <HeaderBanner
        bgImage="Management"
        title="Compensatory Classes"
        currentPage="Compensatory Classes"
      />
      <div className="bannerBotttom h-[3.5rem] w-full"></div>

      <div className="mx-auto max-w-[1300px] px-4">
        {/* Title */}
        <div className="primary-color mt-8 w-72 border-l-4 border-[#32727a] pl-3 text-2xl font-bold md:w-[28rem] md:text-[45px]">
          Compensatory Classes at LKCTC
        </div>

        {/* Description */}
        <div className="mt-6 break-all leading-7 text-[#333333]">
          As per the directives issued by the Government of Punjab, the
          Institute remained off from 25-29 Aug 2025. To ensure continuity in
          syllabus coverage, the Institute will conduct compensatory classes
          through hybrid Mode (online/offline) on Saturdays, commencing from
          September 13, 2025 onwards.
        </div>

        {/* Section Header */}
        <div className="font-semibold text-2xl mt-6">
          Compensatory Classes related Notices, SOP, and Time Table
        </div>

        {/* Notices */}
        <h3 className="font-semibold text-xl mt-4">📌 Notices</h3>
        {files.notices.map((file, i) => (
          <div key={i} className="font-normal p-2 underline text-lg">
            <a href={file.path} target="_blank" rel="noreferrer">
              {file.name}
            </a>
          </div>
        ))}

        {/* SOP */}
        <h3 className="font-semibold text-xl mt-6">📄 SOP</h3>
        {files.sop.map((file, i) => (
          <div key={i} className="font-normal p-2 underline text-lg">
            <a href={file.path} target="_blank" rel="noreferrer">
              {file.name}
            </a>
          </div>
        ))}

        {/* Timetables */}
        <h3 className="font-semibold text-xl mt-6">📚 Time Tables</h3>
        {files.timetables.map((file, i) => (
          <div key={i} className="font-normal p-2 underline text-lg">
            <a href={file.path} target="_blank" rel="noreferrer">
              {file.name}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompensatoryClasses;
